
eval("define(\'text!keyboard.json\',[],function () { return \'{\\n    \"recentProjects\": [\\n        {\\n            \"key\": \"Ctrl-Alt-R\"\\n        }\\n    ]\\n}\';});\n\n//# sourceURL=/text!keyboard.json");

